/// <reference path="../../adpIntegration/sections/adpIntegration.main.section.ts" />

module Meevo.Plugins.AdpRunIntegration {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class RunMainSection extends Meevo.Plugins.AdpIntegration.MainSection {

        private enableStatus: boolean;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            modalService: Meevo.Components.Modal.IModalService,
            busyService: Meevo.Components.Busy.IBusyService,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                modalService,
                busyService,
                sectionSecurityKey)
        }

        CanChangeIntegrationStatus(): boolean {
            return this.model.isAdpMarketplaceSubscriptionActive &&
                this.model.consentCompleted && this.model.canEnableStatus;
        }
    }
}